import { render, staticRenderFns } from "./donor-teams-public-reply.vue?vue&type=template&id=2a665d72&scoped=true&"
import script from "./donor-teams-public-reply.vue?vue&type=script&lang=js&"
export * from "./donor-teams-public-reply.vue?vue&type=script&lang=js&"
import style0 from "./donor-teams-public-reply.vue?vue&type=style&index=0&id=2a665d72&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a665d72",
  null
  
)

export default component.exports